import React from "react"
import { ErrorBoundary } from "../ErrorBoundary"

export function renderNullOnError(Component: () => JSX.Element): () => JSX.Element
export function renderNullOnError<T extends JSX.IntrinsicAttributes>(
  Component: (props: T) => JSX.Element,
) {
  return (props: T) => (
    <ErrorBoundary renderOnError={() => null}>
      <Component {...props} />
    </ErrorBoundary>
  )
}
